export default __webpack_public_path__ + "img/dSXOkpNb.f116e15b.svg";